<template>
  <div class="whisper-box">
    <div class="whisper-header">
      <h3>{{ componentData.title || componentData.description || 'Whisper Box' }}</h3>
      <p v-if="componentData.customdescription" v-html="componentData.customdescription"></p>
    </div>

    <div v-if="!submitted">
      <textarea
        v-model="message"
        placeholder="Share your anonymous thoughts, feedback, or questions..."
        rows="4"
      ></textarea>
      <button
        @click="submitFeedback"
        :disabled="!message.trim()"
        class="submit-button"
      >
        Send Anonymously
      </button>
    </div>

    <div v-else class="success-message">
      <p>Thanks for your message! It's been sent anonymously.</p>
    </div>
  </div>
</template>

<script>
import { fb } from './firebaseconfig';

let db = fb.database();

export default {
  name: 'WhisperBox',
  props: {
    componentData: {
      type: Object,
      required: true
    },
    linkId: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      message: '',
      submitted: false
    };
  },
  methods: {
    submitFeedback() {
      if (!this.message.trim()) return;

      // Reference to the specific component's feedback collection
      const feedbackRef = db.ref(`users/${this.userId}/links/${this.linkId}/feedback`);
      
      // Add the new feedback item
      feedbackRef.push({
        message: this.message,
        timestamp: Date.now(),
        read: false
      }).then(() => {
        // Reset form and show success message
        this.message = '';
        this.submitted = true;
        
        // Reset the submission status after 5 seconds
        setTimeout(() => {
          this.submitted = false;
        }, 5000);
        
        // Optionally, you can emit an event to notify the parent component
        this.$emit('feedback-submitted');
      }).catch(error => {
        console.error('Error submitting feedback:', error);
      });
    }
  }
}
</script>

<style scoped>
.whisper-box {
  background-color: #f8f8f8;
  border-radius: 8px;
  padding: 16px;
  max-width: 500px;
  margin: 0 auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.whisper-header {
  margin-bottom: 16px;
  text-align: center;
}

.whisper-header h3 {
  margin-top: 0;
  font-size: 18px;
  color: #333;
  font-weight: bold;
}

textarea {
  width: 100%;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #ddd;
  margin-bottom: 12px;
  font-family: inherit;
  box-sizing: border-box;
  resize: vertical;
  background-color: white;
}

.submit-button {
  background-color: #8a2be2;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: bold;
  width: 100%;
  transition: background-color 0.3s;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.submit-button:hover {
  background-color: #7928a1;
}

.submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.success-message {
  padding: 16px;
  background-color: #e6ffe6;
  border-radius: 6px;
  color: #006600;
  text-align: center;
  font-weight: bold;
}
</style> 


// WEBPACK FOOTER //
// src/components/whisper_box.vue